(function($) {
	$.fn.atdIntegrationForm = function() {

		const executeDownload = (url) => {
			const link = document.createElement('a');
			link.href = url;
			link.click();
			link.remove();
		}

		const doAjax = ($self, config, callback) => {
			const {ajaxConfig, formData, $msgContainer} = config;
			
			$self.ajaxRunning = true;
			
			//setup before
			$msgContainer.html('');
			$self.attr('atd-status', 'ajax-running');
			
			$.ajax({
				url: ajaxConfig.url,
				data: formData,
				method: 'POST',
			}).done((resp) => {
				$self.attr('atd-status', '');
				if (resp.success) {
					$msgContainer.append(`<div class="alert alert-success" role="alert">${resp.data.msg}</div>`);
					setTimeout(() => {
						if(resp.data.download_resource){
							executeDownload(resp.data.download_resource);
						}else{
							if(resp.data.redirect_url){
								window.location.href = resp.data.redirect_url;
							}
						}
					}, 2500);
				} else {
					$msgContainer.append(`<div class="alert alert-danger" role="alert">${resp.data.msg}</div>`);
				}
			}).fail(() => {
				alert('There was an error processing your request, please try again later.');
				$self.attr('atd-status', '');
			}).always(() => {
				$self.ajaxRunning = false;
				if (callback) callback();
			});
		};
		
		return this.each(function() {
			const $self = $(this);
			const ajaxConfig = JSON.parse($self.attr('atd-ajax-config') || '{}');
			const $msgContainer = $self.find('.msg-container');
			
			$self.on('submit', (ev) => {
				ev.preventDefault();
				
				const formData = {...$self.serializeArray().reduce(function(obj, item) {
					obj[item.name] = item.value;
					return obj;
				}, {}), ...ajaxConfig};
				
				doAjax($self, {
					ajaxConfig: ajaxConfig,
					formData: formData,
					$msgContainer: $msgContainer,
				});
			});
		});
	};
	
	$(() => {
		$('form.atd-integration-form').atdIntegrationForm();
	});
})(jQuery);

